import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-foreground text-background py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="mb-4">
              <img 
                src="/images/logo-firma.png" 
                alt="Pneu-Idris Logo" 
                className="h-24 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-background/80 text-sm leading-relaxed">
              Ihr vertrauenswürdiger Partner für professionelle Reifenentsorgung und Grosshandel. 
              Kantonal bewilligt und umweltfreundlich.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Kontakt</h4>
            <div className="space-y-3 text-sm text-background/80">
              <div className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <div>
                  <p>Hutmattstrasse 5</p>
                  <p>5724 Dürrenäsch</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <a href="tel:+41788056066" className="hover:text-secondary transition-colors">
                  078 805 60 66
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <a href="mailto:info@pneu-idris.ch" className="hover:text-secondary transition-colors">
                  info@pneu-idris.ch
                </a>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Dienstleistungen</h4>
            <ul className="space-y-2 text-sm text-background/80">
              <li>Reifenentsorgung</li>
              <li>Grosshandel Reifen</li>
              <li>Felgen aller Art</li>
              <li>Abholservice</li>
              <li>B2B-Lösungen</li>
              <li>Beratung</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background/20 pt-8 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
          <p className="text-sm text-background/70">
            © {new Date().getFullYear()} Pneu-Idris. Alle Rechte vorbehalten.
          </p>
          <div className="flex space-x-6 text-sm text-background/70">
            <button className="hover:text-secondary transition-colors">Datenschutz</button>
            <button className="hover:text-secondary transition-colors">Impressum</button>
            <button className="hover:text-secondary transition-colors">AGB</button>
          </div>
        </div>

        <div className="mt-6 text-center">
          <p className="text-xs text-background/60">
            Betriebsnummer: 413400028 | Verantwortlich: Herr Louay Idris
          </p>
        </div>
      </div>
    </footer>
  );
};
